import naja from 'naja';
import { LiveForm, Nette } from 'live-form-validation';
import Inputmask from 'inputmask';
import $ from 'jquery';
import Swal from 'sweetalert2';

import qrcode from 'qrcode-generator'; 
import css from "./styles.scss";

LiveForm.setOptions({
    showValid: true,
    controlErrorClass: 'input_holder--error',
    controlValidClass: 'input_holder--success',
    showAllErrors: true,
    messageErrorPrefix: '',
    showMessageClassOnParent: 'form-group'
});

global.Nette = Nette;
global.LiveForm = LiveForm;

function splitComma(value) {
    return (value || '')
        .split(',')
        .map(item => item.trim())
        .filter(Boolean);
}

function getDomElement(elem) {
    return elem instanceof $ ? elem[0] : elem;
}

function isQuestionnaireSelected(questionnaire) {
    if (!questionnaire || !questionnaire.id) {
        return false;
    }

    const form = questionnaire.closest('form') || document;
    const toggles = Array.from(form.querySelectorAll('[data-toggle-section]'));
    if (toggles.some(input => input.dataset.toggleSection === questionnaire.id && input.checked)) {
        return true;
    }

    const linkedInputIds = Array.from(questionnaire.querySelectorAll('[data-toggle-uncheck]'))
        .flatMap(element => splitComma(element.dataset.toggleUncheck));

    return linkedInputIds.some(id => {
        const input = document.getElementById(id);
        return input && input.checked;
    });
}

function shouldSkipHiddenControlValidation(elem) {
    const el = getDomElement(elem);
    const hiddenAncestor = el?.closest?.('[hidden]');

    if (!hiddenAncestor) {
        return false;
    }

    if (
        hiddenAncestor.classList.contains('toggle-inner-modal') &&
        hiddenAncestor.classList.contains('questionnaire') &&
        isQuestionnaireSelected(hiddenAncestor)
    ) {
        return false;
    }

    return true;
}

// Skip validation for controls inside hidden ancestors
const _netteValidateControl = Nette.validateControl;
Nette.validateControl = function(elem, rules, onlyCheck, value, emptyOptional) {
    if (shouldSkipHiddenControlValidation(elem)) {
        return true;
    }
    return _netteValidateControl.apply(this, arguments);
};

const NajaLiveValidationFallback = {
    initialize(naja){
        naja.addEventListener('init', function() {
            document.querySelectorAll('input[type="submit"], input[type="button"], form button').forEach(element => {
                element.addEventListener('click', this.processForm);
            });
        }.bind(this));
    },

    processForm(event) {
        const element = event.target;
        if (element.form !== undefined && element.form !== null) {
            element.form['nette-submittedBy'] = element;
        }
    }
}

const NajaPreventDoubleSubmission = {
    initialize(naja){
        naja.addEventListener('init', function() {
            // Prevent Double Submits
            document.querySelectorAll('form').forEach(form => {
                form.addEventListener('submit', (e) => {
                    if ((typeof form.validationState === "undefined") || (form.validationState == true)){
                        // Prevent if already submitting
                        if (form.classList.contains('is-submitting')) {
                            e.preventDefault();
                        }
                        // Add class to hook our visual indicator on
                        form.classList.add('is-submitting');
                    }
                });
            });
        }.bind(this));
    }
}

safeRun(() => {
    const birthInput = document.querySelector('[name="birth"]');
    if (birthInput) {
        birthInput.addEventListener('blur', function () {
            this.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }
});

naja.addEventListener('success', (event) => {
    if (event.detail.payload.success) {
        const target = document.getElementById('h1');
        if (target) {
            target.scrollIntoView({ behavior: 'smooth' });
        }
    }

    if (event.detail.payload.flashes) {
        const target = document.getElementById('snippet--flashes');
        if (target) {
            target.scrollIntoView({behavior: 'smooth', block: 'start'});
        }
    }
});

function safeRun(fn) {
        if (document.readyState === "loading") {
                document.addEventListener("DOMContentLoaded", fn);
            } else {
                fn();
            }
    }

safeRun(() => {
    naja.registerExtension(NajaLiveValidationFallback);
    //naja.registerExtension(NajaPreventDoubleSubmission);
    naja.initialize();
    Nette.initOnLoad();
    naja.snippetHandler.addEventListener('afterUpdate', (event) => {
        $(event.snippet).find('form').each(function() {
            window.Nette.initForm(this);
        });
        $(event.snippet).find('.fade-on-load').each(function(){
            $(this).hide().fadeIn();
        });
        initDynamicUi(event.snippet);
    });
    initDynamicUi(document);
});
Nette.origIsDisabled = Nette.isDisabled;
Nette.isDisabled = function(elem){
    var result = Nette.origIsDisabled(elem);
    if (!result){
        result = elem.classList.contains('validation-waiting');
    }
    return result;
}

Nette.origValidateForm = Nette.validateForm;
Nette.validateForm = function(sender, onlyCheck){
    const form = sender instanceof HTMLFormElement ? sender : (sender.form || sender.closest?.('form'));
    var result = Nette.origValidateForm(sender, onlyCheck);
    if (result){
        Array.from((form || sender).querySelectorAll('template.fire-on-submit')).forEach((template) => {
            if (!result) return;
            var style = window.getComputedStyle(template.parentElement);
            if (style.display !== 'none'){
                result = false;
                Swal.fire({template: template}).then((swalResult) => {
                    if (swalResult.isConfirmed){
                        sender.classList.add("is-submitting");
                        sender.submit();
                    } else {
                        sender.classList.remove("is-submitting");
                    }
                });
            }
        });
    }

    // prevent dbl-submit
    if (result && form) {
        if (form.classList.contains('is-submitting')) {
            result = false;
        } else {
            form.classList.add('is-submitting');
        }
    }

    if (!result && form) {
        const firstInvalid = findFirstInvalidControl(form);
        if (firstInvalid) {
            revealInvalidControl(firstInvalid);
        }
    }

    sender.validationState = result;
    return result;
}


Nette.validators['AppLibValidatorQuestionnaireValidators_oneOf'] = (elem, args, val) => {
    const values = Array.isArray(val)
        ? val
        : (val === null || typeof val === 'undefined' || val === '' ? [] : [val]);

    return values.some(value => args.includes(value));
};

Nette.validators['AppLibValidatorQuestionnaireValidators_exclusiveOptions'] = (elem, args, val) => {
    const values = Array.isArray(val)
        ? val
        : (val === null || typeof val === 'undefined' || val === '' ? [] : [val]);

    return !values.some(value => args.includes(value)) || values.length === 1;
};

Nette.validators['AppLibValidatorQuestionnaireValidators_containsWord'] = (elem, args, val) => {
    return /^(?=.*\p{L}{2})[\p{L}\s'’\/-]+$/u.test((val ?? '').trim());
};

Nette.validators.UIFormJavascriptCallbackValidator_validate = function(elem, args, val) {
    if (args.hasOwnProperty('callback')) {
        if (elem.hasOwnProperty('validationState')){
            switch (elem.validationState){
                case 'valid' : 
                    return true;
                case 'invalid' : 
                    return false;
                case 'waiting' :
                    return ;
            }
        } else {
            elem.addEventListener('change', (event) => {
                elem.validationState = 'changed';
            })
        }
        elem.classList.add('validation-waiting');
        elem.validationState = 'waiting';
                // pro naja 2.5 lze použít string pro identifikaci stornovaného požadavku
        var uniqueId = elem.form.id + '-' + elem.name;
        naja.makeRequest('GET', args.callback, { value: val }, { history: false, snippets: true, abort: false, unique: uniqueId })
            .then((response) => {
                elem.classList.remove('validation-waiting');
                elem.validationState = response.result ? 'valid' : 'invalid';
                if (response.result) {
                    LiveForm.removeError(elem);
                } else {
                    LiveForm.addError(elem,
                        response.hasOwnProperty('message') ? response.message :
                            args.hasOwnProperty('message') ? args.message :
                                'Please enter a valid value.'
                    );
                }
            })
        ;
        return ;
    }
    return true;
};

function restoreConfirmedConsentCheckbox(input) {
    input.dataset.confirmUncheckRestoring = '1';
    input.checked = true;
    $(input).trigger('change');
    delete input.dataset.confirmUncheckRestoring;
}

$(document).on('click', '.toggle_box__item-header', function() {
    $(this).closest(".toggle_box__item").toggleClass('active');
}).on('click', '.main_menu_toggler', function() {
    $(this).toggleClass("active").find('.menu_icon').toggleClass('open');
    $('.main_menu').fadeToggle();
}).on('click', '.fake_select__title', function() {
    $(this).closest('.fake_select').toggleClass('active');
}).on('mousedown', '.product_item', function() {
    var $radio = $(this).find('input[type="radio"]');
    if ($radio.prop('checked')) {
        $(this).on('mouseup.uncheck', function () {
            setTimeout(function () {
                $radio.prop('checked', false).trigger('change');
            }, 5);
            $(this).off('mouseup.uncheck'); // unbind jen náš custom event
        });
    } else {
        $(".fake_select__inner input:radio[name='barva']").prop('checked', false);
        $('.fake_select__title.barva').html('Vyberte barvu zařízení');
    }
}).on('change', 'input[type="checkbox"][data-group]', function () {
    let group = $(this).data('group');
    if (!group || !this.checked) {
        return;
    }

    $(`input[data-group="${group}"]`).not(this).filter(':checked').prop('checked', false).trigger('change');
}).on('change', 'input[data-confirm-uncheck-consent="1"]', function() {
    if (this.dataset.confirmUncheckRestoring === '1' || this.checked) {
        return;
    }

    const input = this;
    Swal.fire({
        icon: 'warning',
        title: input.dataset.confirmUncheckTitle || 'Zrušit souhlas?',
        html: input.dataset.confirmUncheckText || 'Opravdu chcete zrušit již udělený souhlas?',
        showCancelButton: true,
        confirmButtonText: input.dataset.confirmUncheckConfirm || 'Ano, zrušit souhlas',
        cancelButtonText: input.dataset.confirmUncheckCancel || 'Nechat souhlas',
        customClass: {
            actions: 'submit_holder',
        },
        didOpen: function(popup) {
            const actions = popup.querySelector('.swal2-actions');
            if (actions) {
                actions.classList.add('submit_holder');
            }
        },
        reverseButtons: true,
    }).then(function(result) {
        if (!result.isConfirmed) {
            restoreConfirmedConsentCheckbox(input);
        }
    });
}).on('click', '[data-registration-usage-toggle]', function(e) {
    e.preventDefault();

    const $link = $(this);
    const expanded = $link.data('expanded') === true;
    const $container = $link.closest('[data-registration-product-usage]');

    $container.find('.registration-product-usage-extra').toggleClass('d-none', expanded);
    $link.text(expanded ? $link.data('showText') : $link.data('hideText'));
    $link.data('expanded', !expanded);
}).on('click', '.brand_select__item', function() {
    $(".product_item input:radio[name='zarizeni']").prop('checked', false);
    $(".fake_select__inner input:radio[name='barva']").prop('checked', false);
    $('.fake_select__title.barva').html('Vyberte zařízení');
}).on("click", function(event){
    if(!$(event.target).closest(".fake_select").length){
        $(".fake_select").toggleClass('active', false);
    }
}).on('click', '.fake_select label', function() {
    const $fakeSelect = $(this).closest('.fake_select');
    $fakeSelect.find('.fake_select__title').html('<div class="color_selected">' + $(this).html() + '</div>');
    $fakeSelect.find('.fake_select__inner input').checked = true;
    $fakeSelect.toggleClass('active');
}).on('keypress', 'form', function (e) {
    var code = e.keyCode || e.which;
    if (code == 13) {
        e.preventDefault();
        $('input[type=submit][name=submit]').click();
        return false;
    }
}).on('submit', 'form', function() {
    var $this = $(this);
    if (typeof $this.valid == 'undefined'){
        return true;
    }
    if (!$(this).valid()) return false;
    $('input[type=submit]').attr("disabled", "disabled");
    return true;
}).on('click', '.filling_metter__more', function (e) {
    e.preventDefault();
    $('.filling__registered_sets').slideToggle();
    $(this).toggleClass('active');
}).on('click', '[data-toggle-uncheck]', function(e){
    splitComma(this.dataset.toggleUncheck).forEach(id => {
        $('#' + id).prop('checked', false).trigger('change');
    });
}).on('click', '.validate_modal', function(e){
    let valid = true;
    let firstInvalid = null;
    $(this).closest(".modal_wrapper").find('input, select, textarea').not(':button, :submit, :reset, [disabled]').filter(function() {
        return !$(this).closest('[hidden]').length;
    }).each(function(){
        const el = this;
        if (!Nette.validateControl(el)){
            valid = false;
            if (!firstInvalid) {
                firstInvalid = el;
            }
        }
        return valid;
    });
    if (!valid){
        e.preventDefault();
        e.stopImmediatePropagation();

        if (firstInvalid) {
            const $el = $(firstInvalid);
            const $modalInner = $el.closest('.modal_inner');
            const messageId = firstInvalid.dataset?.lfvMessageId;
            const $target = messageId ? $('#' + messageId) : $el;
            const targetTop = $target.length ? $target.position().top : $el.position().top;

            if ($modalInner.length && typeof targetTop !== 'undefined') {
                $modalInner.scrollTop(Math.max(0, targetTop - 24));
            }

            firstInvalid.focus();
        }
    }
}).on('click', '.modal_wrapper .close_modal', function(e){
    e.preventDefault();
    closeQuestionnaireModal($(this).closest(".modal_wrapper")[0]);
}).on('input', '.number_code input', function(){

    // Get the current input field
    var $this = $(this);

    // Ensure only one number is entered
    var value = $this.val().replace(/[^0-9]/g, '');
    if (value.length > 1) {
        value = value.slice(-1);
    }
    $this.val(value);
    syncNumberCode($this.closest('.number_code')[0]);

    // Add the "filled" class if there is a number, otherwise remove it
    if (value) {
        $this.addClass('filled');
    } else {
        $this.removeClass('filled');
    }

    // Automatically move to the next input if there is a number
    if (value) {
        var $nextInput = $this.nextAll('input').first();

        if ($nextInput.length > 0) {
            // Focus the next input
            $nextInput.focus();
        } else {
            // Check if all inputs are filled before submitting the form
            var $form = $this.closest('form');
            var allFilled = $this.closest('.number_code').find('input').toArray().every(function (input) {
                return $(input).val().trim() !== '';
            });

            if (allFilled) {
                submitNumberCodeForm($form[0]);
            }
        }
    }

}).on('keydown', '.number_code input', function (e) {
    const $this = $(this);
    if (e.key === 'Backspace' && !$this.val()) {
        const $prevInput = $this.prevAll('input').first();
        if ($prevInput.length > 0) {
            $prevInput.focus();
        }
    } else if (e.key === 'ArrowLeft') {
        $this.prevAll('input').first().focus();
    } else if (e.key === 'ArrowRight') {
        $this.nextAll('input').first().focus();
    }
});

function getScope(root) {
    return root && typeof root.querySelectorAll === 'function' ? root : document;
}

function findAll(root, selector) {
    const scope = getScope(root);
    const elements = Array.from(scope.querySelectorAll(selector));

    if (scope.matches?.(selector)) {
        elements.unshift(scope);
    }

    return elements;
}

function initDynamicUi(root) {
    initMasks(root);
    initQrCodes(root);
    initDisplayAfter(root);
    initBodyFixedContent(root);
    initSmsCode(root);
    initDataToggleSections(root);
    initQuestionnaireConditionals(root);
    initQuestionnaireFollowUps(root);
    initQuestionnaireAnswerAlerts(root);
    initQuestionnaireWizards(root);
    initRetailVeloOffers(root);
}

function initMasks(root) {
    Inputmask().mask(findAll(root, 'input[data-inputmask]'));
    Inputmask({
        alias: "datetime",
        inputFormat: "dd.mm.yyyy",
        placeholder: "dd.mm.rrrr",
        showMaskOnHover: false,
        showMaskOnFocus: false,
        clearIncomplete: false,
    }).mask(findAll(root, 'input[name="birth"]'));
}

function initQrCodes(root) {
    findAll(root, '.generate-qr').forEach((element) => {
        if (element.dataset.qrInitialized === '1') {
            return;
        }

        const qr = qrcode(element.dataset.type ?? 0, element.dataset.erroCorrection ?? 'L');
        qr.addData(element.dataset.data);
        qr.make();
        element.innerHTML = qr.createSvgTag({
            "cellSize": 4,
            "margin": 4,
            "scalable": false
        });
        element.dataset.qrInitialized = '1';
    });
}

function initDisplayAfter(root) {
    findAll(root, '[data-display-after]').forEach((element) => {
        if (element.dataset.displayAfterInitialized === '1') {
            return;
        }

        const displayDate = new Date(element.dataset.displayAfter * 1000);
        const waitFor = displayDate - Date.now();
        const showElement = () => element.classList.remove('d-none');

        if (waitFor <= 0) {
            showElement();
        } else {
            setTimeout(showElement, waitFor);
        }

        element.dataset.displayAfterInitialized = '1';
    });
}

function initBodyFixedContent(root) {
    const hasFixedContent = findAll(document, '.fixed_content').length > 0;
    document.body.classList.toggle('fixed-buttons', hasFixedContent);
}

function initSmsCode(root) {
    findAll(root, '.number_code').forEach((holder) => {
        Array.from(holder.querySelectorAll('input')).forEach((input) => {
            input.classList.toggle('filled', input.value.trim() !== '');
        });

        syncNumberCode(holder);
    });

    const input = getScope(root).querySelector?.('.focusMe') || document.querySelector('.focusMe');
    if (input && (!document.activeElement || document.activeElement === document.body)) {
        input.focus();
        input.setSelectionRange?.(input.value.length, input.value.length);
    }
}

function syncNumberCode(holder) {
    if (!holder) {
        return;
    }

    const form = holder.closest('form');
    const hiddenInput = form?.querySelector('input[name="kod_register"]') || document.getElementById('kod_register');
    if (!hiddenInput) {
        return;
    }

    hiddenInput.value = Array.from(holder.querySelectorAll('input'))
        .map(input => input.value.trim())
        .join('');
}

function submitNumberCodeForm(form) {
    if (!form) {
        return;
    }

    const submitter = form.querySelector('input[type="submit"][name="submit"], button[type="submit"][name="submit"], input[type="submit"], button[type="submit"]');
    if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(submitter || undefined);
    } else if (submitter) {
        submitter.click();
    }
}

function initDataToggleSections(root) {
    findAll(root, '[data-toggle-section]').forEach((input) => {
        const update = (open) => {
            const section = document.getElementById(input.dataset.toggleSection);
            if (section) {
                setSectionHidden(section, !input.checked, { open });
            }
        };

        if (input.dataset.toggleSectionBound !== '1') {
            input.addEventListener('change', () => update(true));
            input.dataset.toggleSectionBound = '1';
        }

        update(false);
    });
}

function initQuestionnaireConditionals(root) {
    const controls = findAll(root, 'input[type="radio"][data-hide-sections], input[type="radio"][data-show-sections], input[type="checkbox"][data-hide-sections], input[type="checkbox"][data-show-sections], input[type="checkbox"][data-exclusive-option]');

    controls.forEach((control) => {
        if (control.dataset.questionnaireConditionalBound === '1') {
            return;
        }

        control.addEventListener('change', () => {
            if (control.type === 'radio') {
                updateRadioConditionalGroup(control, true);
            } else {
                enforceExclusiveCheckboxOption(control);
                updateCheckboxConditionalGroup(control, true);
            }
        });

        control.dataset.questionnaireConditionalBound = '1';
    });

    const initializedGroups = new Set();
    controls.forEach((control) => {
        const key = `${control.form?.id || ''}:${control.name}:${control.type}`;
        if (initializedGroups.has(key)) {
            return;
        }
        initializedGroups.add(key);

        if (control.type === 'radio') {
            updateRadioConditionalGroup(control, false);
        } else {
            updateCheckboxConditionalGroup(control, false);
        }
    });
}

function getNamedControlGroup(control) {
    const scope = control.form || document;
    return Array.from(scope.querySelectorAll('input'))
        .filter(item => item.name === control.name && item.form === control.form);
}

function collectAffectedSections(controls) {
    const affected = new Set();
    controls.forEach((control) => {
        splitComma(control.dataset.showSections).forEach(sectionId => affected.add(sectionId));
        splitComma(control.dataset.hideSections).forEach(sectionId => affected.add(sectionId));
    });
    return affected;
}

function resetAffectedSections(affected, open) {
    affected.forEach((sectionId) => {
        const section = document.getElementById(sectionId);
        if (!section) {
            return;
        }

        rememberInitialSectionState(section);
        setSectionHidden(section, section.dataset.initialHidden === 'true', { open: false });
    });
}

function applyControlSectionRules(control, open) {
    splitComma(control.dataset.hideSections).forEach((sectionId) => {
        const section = document.getElementById(sectionId);
        if (section) {
            setSectionHidden(section, true, { open: false });
        }
    });

    splitComma(control.dataset.showSections).forEach((sectionId) => {
        const section = document.getElementById(sectionId);
        if (section) {
            setSectionHidden(section, false, { open });
        }
    });
}

function updateRadioConditionalGroup(control, open) {
    const group = getNamedControlGroup(control)
        .filter(item => item.dataset.hideSections || item.dataset.showSections);
    const checked = group.find(item => item.checked);
    const affected = collectAffectedSections(group);

    recomputeQuestionnaireConditionalSections(control);

    if (open && checked && !checked.closest('[hidden]')) {
        applyControlSectionRules(checked, true);
    }

    refreshAnyVisibilitySections(control, affected, open);
}

function enforceExclusiveCheckboxOption(control) {
    if (!control.checked) {
        return;
    }

    getNamedControlGroup(control).forEach((item) => {
        if (item === control) {
            return;
        }

        if (control.dataset.exclusiveOption || item.dataset.exclusiveOption) {
            item.checked = false;
        }
    });
}

function updateCheckboxConditionalGroup(control, open) {
    const group = getNamedControlGroup(control)
        .filter(item => item.dataset.hideSections || item.dataset.showSections);
    const affected = collectAffectedSections(group);

    recomputeQuestionnaireConditionalSections(control);

    if (open && !control.closest('[hidden]')) {
        applyControlSectionRules(control, true);
    }

    refreshAnyVisibilitySections(control, affected, open);
}

function recomputeQuestionnaireConditionalSections(control) {
    const scope = control.form || document;
    const controls = Array.from(scope.querySelectorAll('input'))
        .filter(item => item.dataset.hideSections || item.dataset.showSections);
    const affected = collectAffectedSections(controls);
    const processedGroups = new Set();

    resetAffectedSections(affected, false);

    controls.forEach((item) => {
        const groupKey = `${item.name}:${item.type}`;
        if (processedGroups.has(groupKey)) {
            return;
        }
        processedGroups.add(groupKey);

        controls
            .filter(candidate => candidate.name === item.name && candidate.type === item.type)
            .filter(candidate => candidate.checked && !hasHiddenConditionalAncestor(candidate, affected))
            .forEach(candidate => applyControlSectionRules(candidate, false));
    });

    refreshAnyVisibilitySections(control, affected, false);
}

function refreshAnyVisibilitySections(control, affected, open) {
    const scope = control.form || document;
    const conditionalControls = Array.from(scope.querySelectorAll('input[data-show-sections]'));
    const conditionalSectionIds = collectAffectedSections(conditionalControls);

    affected.forEach((sectionId) => {
        const section = document.getElementById(sectionId);
        if (!section || section.dataset.questionnaireVisibility !== 'any') {
            return;
        }

        const visible = conditionalControls.some((candidate) => {
            if (!candidate.checked || hasHiddenConditionalAncestor(candidate, conditionalSectionIds)) {
                return false;
            }

            return splitComma(candidate.dataset.showSections).includes(sectionId);
        });

        setSectionHidden(section, !visible, { open: visible && open });
    });
}

function hasHiddenConditionalAncestor(control, conditionalSectionIds) {
    let ancestor = control.parentElement;
    while (ancestor) {
        // A closed modal or inactive wizard step is UI state, not a hidden answer branch.
        if (ancestor.hidden && ancestor.id && conditionalSectionIds.has(ancestor.id)) {
            return true;
        }
        ancestor = ancestor.parentElement;
    }

    return false;
}

function rememberInitialSectionState(section) {
    if (typeof section.dataset.initialHidden === 'undefined') {
        section.dataset.initialHidden = section.hidden ? 'true' : 'false';
    }
}

function isQuestionnaireSection(section) {
    return section?.classList?.contains('toggle-inner-modal') && section.classList.contains('questionnaire');
}

function setSectionHidden(section, hidden, options = {}) {
    if (!section) {
        return;
    }

    rememberInitialSectionState(section);

    if (hidden) {
        if (isQuestionnaireSection(section)) {
            section.querySelectorAll('.modal_wrapper').forEach(wrapper => {
                wrapper.style.display = 'none';
            });
        }
        section.hidden = true;
        return;
    }

    const wasHidden = section.hidden;
    section.hidden = false;

    if (!isQuestionnaireSection(section)) {
        return;
    }

    if (options.open) {
        openQuestionnaireModal(section);
    } else if (wasHidden) {
        section.querySelectorAll('.modal_wrapper').forEach(wrapper => {
            wrapper.style.display = 'none';
        });
    }
}

function openQuestionnaireModal(section, focusTarget = null) {
    const questionnaire = section?.closest?.('.toggle-inner-modal.questionnaire') || section;
    if (!questionnaire) {
        return;
    }

    questionnaire.hidden = false;
    questionnaire.querySelectorAll('.modal_wrapper').forEach((wrapper) => {
        wrapper.style.display = 'block';
    });

    const modalInner = focusTarget?.closest?.('.modal_inner') || questionnaire.querySelector('.modal_inner');
    if (!modalInner) {
        return;
    }

    if (focusTarget) {
        scrollControlIntoModal(focusTarget, modalInner);
    } else {
        modalInner.scrollTo(0, 0);
    }
}

function closeQuestionnaireModal(wrapper) {
    if (!wrapper) {
        return;
    }

    const questionnaire = wrapper.closest('.toggle-inner-modal');
    $(wrapper).fadeOut(function () {
        if (questionnaire) {
            questionnaire.hidden = true;
        }
    });
}

function scrollControlIntoModal(control, modalInner) {
    const messageId = control.dataset?.lfvMessageId;
    const message = messageId ? document.getElementById(messageId) : null;
    const target = message || control;
    const targetRect = target.getBoundingClientRect();
    const innerRect = modalInner.getBoundingClientRect();
    const top = targetRect.top - innerRect.top + modalInner.scrollTop - 24;

    modalInner.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    setTimeout(() => control.focus?.({ preventScroll: true }), 120);
}

function findFirstInvalidControl(form) {
    const controls = Array.from(form.elements)
        .filter(control => control && control.name && !control.disabled)
        .filter(control => !['button', 'submit', 'reset', 'hidden'].includes((control.type || '').toLowerCase()));

    for (const control of controls) {
        if (shouldSkipHiddenControlValidation(control)) {
            continue;
        }

        if (Nette.validateControl(control) === false) {
            return control;
        }
    }

    return null;
}

function revealInvalidControl(control) {
    const questionnaire = control.closest?.('.toggle-inner-modal.questionnaire');
    if (questionnaire) {
        openQuestionnaireModal(questionnaire, control);
        return;
    }

    control.scrollIntoView?.({ behavior: 'smooth', block: 'center' });
    control.focus?.({ preventScroll: true });
}

function initQuestionnaireFollowUps(root) {
    findAll(root, '.questionnaire-followup[data-follow-up-source][data-follow-up-trigger]').forEach((wrapper) => {
        const form = wrapper.closest('form');
        if (!form) {
            return;
        }

        const update = () => updateQuestionnaireFollowUp(wrapper);
        if (wrapper.dataset.followUpBound !== '1') {
            getQuestionnaireSourceControls(form, wrapper.dataset.followUpSource).forEach((control) => {
                control.addEventListener('change', update);
            });
            wrapper.dataset.followUpBound = '1';
        }

        update();
    });
}

function getQuestionnaireSourceControls(form, source) {
    return Array.from(form.elements).filter((control) => {
        const name = control.name || '';
        return name === `questionnaire[${source}]` || name === `questionnaire[${source}][]`;
    });
}

function updateQuestionnaireFollowUp(wrapper) {
    const form = wrapper.closest('form');
    const source = wrapper.dataset.followUpSource;
    const trigger = wrapper.dataset.followUpTrigger;
    const active = getQuestionnaireSourceControls(form, source).some((control) => {
        if (control.type === 'checkbox' || control.type === 'radio') {
            return control.checked && control.value === trigger;
        }
        return control.value === trigger;
    });

    wrapper.hidden = !active;

    if (!active) {
        wrapper.querySelectorAll('input, textarea, select').forEach((control) => {
            if (control.type === 'checkbox' || control.type === 'radio') {
                control.checked = false;
            } else {
                control.value = '';
            }
        });
    }
}

function initQuestionnaireAnswerAlerts(root) {
    findAll(root, '.questionnaire-answer-alert[data-answer-source][data-answer-trigger]').forEach((alert) => {
        const form = alert.closest('form');
        if (!form) {
            return;
        }

        const update = () => {
            const source = alert.dataset.answerSource;
            const trigger = alert.dataset.answerTrigger;
            alert.hidden = !getQuestionnaireSourceControls(form, source).some((control) => {
                return control.checked && control.value === trigger;
            });
        };

        if (alert.dataset.answerAlertBound !== '1') {
            getQuestionnaireSourceControls(form, alert.dataset.answerSource).forEach((control) => {
                control.addEventListener('change', update);
            });
            alert.dataset.answerAlertBound = '1';
        }

        update();
    });
}

function initQuestionnaireWizards(root) {
    findAll(root, '[data-wizard]').forEach(function(wizard) {
        if (wizard.dataset.wizardInitialized === '1') {
            return;
        }
        wizard.dataset.wizardInitialized = '1';

        var steps = Array.from(wizard.querySelectorAll('[data-wizard-step]'));
        var progressFill = wizard.querySelector('[data-wizard-progress]');
        var progressText = wizard.querySelector('[data-wizard-progress-text]');
        var prevBtn = wizard.querySelector('[data-wizard-prev]');
        var nextBtn = wizard.querySelector('[data-wizard-next]');
        var finishBtn = wizard.querySelector('[data-wizard-finish]');
        var currentIndex = 0;
        var autoAdvanceTimer = null;

        function getVisibleSteps() {
            return steps.filter(function(step) {
                var wrapId = step.dataset.wizardWrap;
                if (wrapId) {
                    var wrapper = document.getElementById(wrapId);
                    if (wrapper && wrapper.closest('[hidden]')) {
                        return false;
                    }
                }
                return true;
            });
        }

        function updateProgress() {
            var visible = getVisibleSteps();
            var visibleIndex = visible.indexOf(steps[currentIndex]);
            if (visibleIndex === -1) visibleIndex = 0;
            var total = visible.length || 1;
            var current = visibleIndex + 1;
            var pct = Math.round((current / total) * 100);

            if (progressFill) progressFill.style.width = pct + '%';
            if (progressText) progressText.textContent = 'Otázka ' + current + ' z ' + total;
        }

        function showStep(index) {
            steps.forEach(function(s) { s.hidden = true; });
            if (steps[index]) {
                steps[index].hidden = false;
                var inner = wizard.closest('.modal_inner');
                if (inner) inner.scrollTo(0, 0);
            }

            var visible = getVisibleSteps();
            var visibleIndex = visible.indexOf(steps[index]);
            var isFirst = visibleIndex <= 0;
            var isLast = visibleIndex >= visible.length - 1;

            if (prevBtn) prevBtn.hidden = isFirst;
            if (nextBtn) nextBtn.hidden = isLast;
            if (finishBtn) finishBtn.hidden = !isLast;

            updateProgress();
        }

        function findNextVisibleIndex(fromIndex) {
            var visible = getVisibleSteps();
            var currentVisibleIdx = visible.indexOf(steps[fromIndex]);
            if (currentVisibleIdx < visible.length - 1) {
                return steps.indexOf(visible[currentVisibleIdx + 1]);
            }
            return -1;
        }

        function findPrevVisibleIndex(fromIndex) {
            var visible = getVisibleSteps();
            var currentVisibleIdx = visible.indexOf(steps[fromIndex]);
            if (currentVisibleIdx > 0) {
                return steps.indexOf(visible[currentVisibleIdx - 1]);
            }
            return -1;
        }

        function validateCurrentStep() {
            var step = steps[currentIndex];
            if (!step) return true;
            var valid = true;
            $(step).find('input, select, textarea').not(':button, :submit, :reset, [disabled]').filter(function() {
                return !shouldSkipHiddenControlValidation(this);
            }).each(function() {
                if (!Nette.validateControl(this)) {
                    valid = false;
                    return false;
                }
            });
            return valid;
        }

        function goNext() {
            if (!validateCurrentStep()) return;
            var nextIdx = findNextVisibleIndex(currentIndex);
            if (nextIdx !== -1) {
                currentIndex = nextIdx;
                showStep(currentIndex);
            }
        }

        function goPrev() {
            var prevIdx = findPrevVisibleIndex(currentIndex);
            if (prevIdx !== -1) {
                currentIndex = prevIdx;
                showStep(currentIndex);
            }
        }

        if (nextBtn) nextBtn.addEventListener('click', goNext);
        if (prevBtn) prevBtn.addEventListener('click', goPrev);

        wizard.querySelectorAll('[data-wizard-auto-advance]').forEach(function(radio) {
            radio.addEventListener('change', function() {
                if (!this.checked) return;
                if (autoAdvanceTimer) clearTimeout(autoAdvanceTimer);
                autoAdvanceTimer = setTimeout(function() {
                    goNext();
                    autoAdvanceTimer = null;
                }, 400);
            });
        });

        var observer = new MutationObserver(function() {
            updateProgress();
            var visible = getVisibleSteps();
            if (visible.indexOf(steps[currentIndex]) === -1 && visible.length > 0) {
                currentIndex = steps.indexOf(visible[0]);
                showStep(currentIndex);
            }
        });

        steps.forEach(function(step) {
            var wrapId = step.dataset.wizardWrap;
            if (wrapId) {
                var wrapper = document.getElementById(wrapId);
                if (wrapper) {
                    observer.observe(wrapper, { attributes: true, attributeFilter: ['hidden'] });
                    if (wrapper.parentElement) {
                        observer.observe(wrapper.parentElement, { attributes: true, attributeFilter: ['hidden'] });
                    }
                }
            }
        });

        showStep(0);
    });
}

function initRetailVeloOffers(root) {
    const scope = getScope(root);
    const prodejnaInput = scope.querySelector?.('#prodejna_register') || document.getElementById('prodejna_register');
    if (!prodejnaInput || prodejnaInput.dataset.retailVeloOffersBound === '1') {
        return;
    }

    const form = prodejnaInput.closest('form') || document;
    const offersConfigElement = form.querySelector('#retail-velo-offers-config') || document.getElementById('retail-velo-offers-config');
    const productItems = Array.from(form.querySelectorAll('[data-retail-velo-offers]'));
    const productGroups = Array.from(form.querySelectorAll('[data-retail-velo-product-group]'));

    if (!offersConfigElement || productItems.length === 0) {
        return;
    }

    let offersConfig = { defaultOffer: null, offers: [] };
    try {
        offersConfig = JSON.parse(offersConfigElement.textContent || '{}');
    } catch (error) {
        return;
    }

    function uncheckHiddenInputs(container) {
        container.querySelectorAll('input[type="checkbox"]:checked').forEach((checkbox) => {
            checkbox.checked = false;
            checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    function setElementHidden(element, hidden) {
        if (hidden) {
            uncheckHiddenInputs(element);
        }
        element.hidden = hidden;
    }

    function setProductDisabled(item, disabled) {
        const input = item.querySelector('input[type="checkbox"]');
        if (!input) {
            return;
        }

        if (disabled && input.checked) {
            input.checked = false;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        }

        input.disabled = disabled;
        item.classList.toggle('sample_card--disabled', disabled);
    }

    function updateProductGridLayout(group) {
        const gridItems = Array.from(group.querySelectorAll('[data-retail-velo-offers]'));
        const visibleItems = gridItems.filter((item) => !item.hidden);

        const layoutClasses = [
            'retail-velo-offer-product--right-column',
            'retail-velo-offer-product--not-top-row',
            'retail-velo-offer-product--last-odd',
            'retail-velo-offer-product--top-left',
            'retail-velo-offer-product--top-right',
            'retail-velo-offer-product--bottom-left',
            'retail-velo-offer-product--bottom-right',
        ];

        gridItems.forEach((item) => item.classList.remove(...layoutClasses));
        visibleItems.forEach((item, index) => {
            const total = visibleItems.length;
            const row = Math.floor(index / 2);
            const rows = Math.ceil(total / 2);
            const column = index % 2;
            const isLastOdd = total % 2 === 1 && index === total - 1;

            if (column === 1 && !isLastOdd) item.classList.add('retail-velo-offer-product--right-column');
            if (row > 0) item.classList.add('retail-velo-offer-product--not-top-row');
            if (isLastOdd) item.classList.add('retail-velo-offer-product--last-odd');
            if (index === 0) item.classList.add('retail-velo-offer-product--top-left');
            if (index === 1 || total === 1) item.classList.add('retail-velo-offer-product--top-right');
            if (row === rows - 1 && (column === 0 || isLastOdd)) item.classList.add('retail-velo-offer-product--bottom-left');
            if (row === rows - 1 && (column === 1 || isLastOdd || total === 1)) item.classList.add('retail-velo-offer-product--bottom-right');
        });
    }

    function offerMatches(offer, value) {
        const codes = offer.codes || [];
        if (codes.includes(value)) {
            return true;
        }

        return (offer.patterns || []).some((pattern) => {
            try {
                return new RegExp(`^(?:${pattern})$`, 'i').test(value);
            } catch (error) {
                return false;
            }
        });
    }

    function resolveOffer(value) {
        const normalizedValue = value.toUpperCase().trim();
        const offers = offersConfig.offers || [];
        if (normalizedValue !== '') {
            const matchedOffer = offers.find((offer) => offerMatches(offer, normalizedValue));
            if (matchedOffer) {
                return matchedOffer.id;
            }
        }

        return offersConfig.defaultOffer || (offers[offers.length - 1] ? offers[offers.length - 1].id : null);
    }

    function updateConsumablesVisibility() {
        const activeOffer = resolveOffer(prodejnaInput.value);

        productItems.forEach((item) => {
            const visibleOffers = (item.dataset.retailVeloOffers || '').split(/\s+/).filter(Boolean);
            const disabledOffers = (item.dataset.retailVeloDisabledOffers || '').split(/\s+/).filter(Boolean);
            setElementHidden(item, !activeOffer || !visibleOffers.includes(activeOffer));
            setProductDisabled(item, !activeOffer || disabledOffers.includes(activeOffer));
        });

        productGroups.forEach((group) => {
            const hasVisibleProduct = Array.from(group.querySelectorAll('[data-retail-velo-offers]'))
                .some((item) => !item.hidden);

            group.hidden = !hasVisibleProduct;
            updateProductGridLayout(group);
        });
    }

    prodejnaInput.addEventListener('input', updateConsumablesVisibility);
    prodejnaInput.addEventListener('change', updateConsumablesVisibility);
    prodejnaInput.dataset.retailVeloOffersBound = '1';
    updateConsumablesVisibility();
}
